module.exports = __webpack_public_path__ + "img/smiljana.c79a2542.jpg";